import React from 'react'
import StepOne from './InvitationDialog'
import StepTwo from './InvitationDialogSuccess'
import Dialog from '../DialogWrapper'

const InvitationDialogContainer = ({ dialog }) => {
  const step = dialog?.data?.step || 1

  return (
    <Dialog dialog={dialog} name='invitation' type='thin'>
      {step === 1 ? <StepOne dialog={dialog} /> : null}
      {step === 2 ? <StepTwo dialog={dialog} /> : null}
    </Dialog>
  )
}

export default InvitationDialogContainer
